const CheckIcon = ({ ...props }) => {
  return (
    <svg width='11' height='8' viewBox='0 0 11 8' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M9.82722 0.217402C9.94242 0.0922846 10.1036 0.0150553 10.2768 0.00197893C10.45 -0.0110974 10.6218 0.0409999 10.7559 0.147299C10.8899 0.253597 10.9759 0.405801 10.9957 0.571855C11.0154 0.737908 10.9674 0.904851 10.8617 1.03752L10.8311 1.07314L4.64968 7.78277C4.53232 7.91014 4.36738 7.98774 4.1908 7.99867C4.01422 8.00959 3.84031 7.95295 3.70695 7.84109L3.67207 7.8096L0.195168 4.44344C0.0726009 4.3249 0.00265663 4.16522 7.41297e-05 3.99806C-0.00250837 3.83089 0.0624726 3.66929 0.181324 3.5473C0.300175 3.42531 0.463615 3.35247 0.637203 3.34412C0.810791 3.33577 0.98097 3.39257 1.11188 3.50254L1.14676 3.53402L4.11956 6.41219L9.82722 0.217402Z'
        fill='var(--pcm-accent-color)'
      />
    </svg>
  );
};

export default CheckIcon;
